// extracted by mini-css-extract-plugin
module.exports = {"hoverBox":"hover-box-module--hover-box--2HCI6"};